import React, { ReactElement, useState } from 'react'
import { resetZoom } from 'store/zoom/zoom'
import { useSnapshot } from 'valtio'

import optimizeViewStore, { OptimizeViewStore } from 'views/OptimizeView/store/optimizeViewStore'
import DataResolutionSwitch from '../../PeriodPicker/DataResolutionSwitch'
import OptimizeViewDateTimePeriodPicker from '../../PeriodPicker/OptimizeViewDateTimePeriodPicker'
import { OutcomeCheckbox } from '../../PeriodPicker/OutcomeCheckbox'

type ZoomResolutionState = OptimizeViewStore['zoomResolutionSwitch']['type']

export default function OptimizeDateRangeSwitch(): ReactElement {
  const optimizeViewSnap = useSnapshot(optimizeViewStore)
  const zoomResolution = optimizeViewSnap.zoomResolutionSwitch.type

  const [resolutionState, setResolutionState] = useState(zoomResolution)
  const isCustomResolution = resolutionState === 'custom'

  const [baseResolutionState, setBaseResolutionState] = useState(zoomResolution)
  // Keep local state in sync if the optimize view store resolution changes
  // externally (e.g. multiple switch components or store reset when switching system).
  if (baseResolutionState !== zoomResolution) {
    setBaseResolutionState(zoomResolution)
    setResolutionState(zoomResolution)
  }

  const handleDataResolutionSwitchChange = (value: ZoomResolutionState): void => {
    // Reflect the change in the UI immediately (e.g. to open the custom date picker)
    setResolutionState(value)

    // Hold off with updating the store until the user has selected a custom date
    if (value !== 'custom') {
      optimizeViewStore.zoomResolutionSwitch = { type: value }
      setBaseResolutionState(value)
      resetZoom()
    }
  }

  const handleCustomPeriodChange = (period: { startTime: ISODateTime; endTime: ISODateTime }): void => {
    optimizeViewStore.zoomResolutionSwitch = { type: 'custom', ...period }
    setBaseResolutionState('custom')
    resetZoom()
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <DataResolutionSwitch onClick={handleDataResolutionSwitchChange} value={resolutionState} />

      {!isCustomResolution && <OutcomeCheckbox />}

      {isCustomResolution && <OptimizeViewDateTimePeriodPicker handlePeriodChange={handleCustomPeriodChange} />}
    </div>
  )
}
